import { selectCurrentEntitiesDenormalizedByType } from 'ducks/entities/selectors'
import { createBasicSelector } from 'util/redux'

export const selectDiscounts = createBasicSelector(state =>
  selectCurrentEntitiesDenormalizedByType(state, 'discount')
)
